import { render, staticRenderFns } from "./uploadInvoice.vue?vue&type=template&id=b6ab39fa&scoped=true"
import script from "./uploadInvoice.vue?vue&type=script&lang=js"
export * from "./uploadInvoice.vue?vue&type=script&lang=js"
import style0 from "./uploadInvoice.vue?vue&type=style&index=0&id=b6ab39fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ab39fa",
  null
  
)

export default component.exports